import _ from 'lodash'

import i18n from '@/i18n/i18n'
import ProductService from '@/services/admin/ProductService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

import { PRODUCT_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true

export const state = {
  products: null,
  product: {},
  meta: null,
  units: null
}
export const allowedFilters = [
  'name',
  'id',
  'subCategory.category_id',
  'sub_category_id',
  'base_unit_id',
  'mobile_active',
  'status',
  'region_ids',
  'sales_channel_ids',
  'only_has_market_price',
  'reverse_vat',
  'gts'
]

export const allowedSorts = ''
export const allowedIncludes = ''
export const allowedAppends = 'image'

export const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products.data
    state.meta = products.meta
  },
  SET_PRODUCT(state, product) {
    state.product = product
  },
  SET_PRODUCT_IMAGE(state, image) {
    state.product.image = image.file
  },
  SET_PRODUCT_REGIONS(state, regions) {
    state.product.regions = regions

    let index = _.findIndex(state.products, function (p) {
      return (p.id = state.product.id)
    })

    if (index !== -1) {
      state.products[index].regions = regions
    }
  },
  SET_PRODUCT_BRANDS(state, brands) {
    state.product.brands = brands

    let index = _.findIndex(state.products, function (p) {
      return (p.id = state.product.id)
    })

    if (index !== -1) {
      state.products[index].brands = brands
    }
  },
  UPDATE_PRODUCT(state, product) {
    let index = _.findIndex(state.products, function (p) {
      return (p.id = product.id)
    })

    if (index !== -1) {
      state.products[index] = product
    }
  },
  ADD_PRODUCT(state, product) {
    state.products.push(product)
  },
  SET_UNITS(state, units) {
    state.units = units
  },
  ADD_CATEGORY(state, product) {
    state.products.push(product)
  },
  SET_PRODUCT_UNITS(state, productUnits) {
    state.product.units = productUnits
  },
  DELETE_PRODUCT(state, product) {
    state.products = state.products.filter(item => {
      return item.id !== product.id
    })
    state.meta.total--
  }
}

export const getters = {
  getProductById: state => id => {
    return state.products ? state.products.find(product => product.id === id) : false
  }
}

export const actions = {
  getProducts({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      ProductService.getProducts(newQuery)
        .then(response => {
          commit('SET_PRODUCTS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: PRODUCT_ERROR_MESSAGES.getProductsError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getMobileProducts({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      ProductService.getMobileProducts(newQuery)
        .then(response => {
          commit('SET_PRODUCTS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.product.mobile_app_products')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateProduct({ commit, state, getters }, id) {
    return new Promise(resolve => {
      ProductService.getProduct(id).then(response => {
        commit('SET_PRODUCT', response.data)
        resolve(response.data)
      })
    })
  },
  getProduct({ commit, state, getters }, id) {
    if (id == state.product.id) return state.product

    let product = getters.getProductById(id)

    if (product) {
      commit('SET_PRODUCT', product)
      return product
    } else {
      return new Promise(resolve => {
        ProductService.getProduct(id).then(response => {
          commit('SET_PRODUCT', response.data)
          resolve(response.data)
        })
      })
    }
  },
  createProduct({ dispatch, commit, state }, product) {
    return new Promise((resolve, reject) => {
      ProductService.createProduct(product)
        .then(response => {
          if (state.products) {
            commit('ADD_PRODUCT', response.data)
          }

          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.product.product')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editProduct({ dispatch, commit }, product) {
    return new Promise((resolve, reject) => {
      ProductService.editProduct(product.productItem.id, product)
        .then(response => {
          commit('SET_PRODUCT', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.product.product')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getUnits({ commit, state }) {
    if (state.units) return state.units

    return new Promise(resolve => {
      ProductService.getUnits().then(response => {
        commit('SET_UNITS', response.data)
        resolve(response.data)
      })
    })
  },
  saveProductUnits({ commit, state, dispatch }, params) {
    return new Promise((resolve, reject) => {
      ProductService.saveProductUnits(params.productId, params.units)
        .then(response => {
          commit('SET_PRODUCT_UNITS', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.saved', {
              element: t('store.admin.product.product_units')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.save_error', {
                element: t('store.admin.product.product_units')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteProductUnitItem({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      ProductService.deleteProductUnitItem(params.productId, params.unitId)
        .then(response => {
          commit('SET_PRODUCT_UNITS', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.removed', {
              element: t('store.admin.product.product_units')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.remove_error', {
                element: t('store.admin.product.product_units')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteProduct({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      ProductService.deleteProduct(params.id)
        .then(response => {
          commit('DELETE_PRODUCT', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.product.product')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.delete_error', {
              element: t('store.admin.product.product')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportProducts({ dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)

    return new Promise(reject => {
      ProductService.exportProducts(newQuery)
        .then(() => {
          const notification = {
            type: 'info',
            message: t('store.shared.exporting', {
              element: t('store.admin.product.products')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.exporting_error', {
                element: t('store.admin.product.products')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  uploadImage({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      ProductService.uploadImage(params.id, params.form)
        .then(response => {
          commit('SET_PRODUCT_IMAGE', response)
          const notification = {
            type: 'success',
            message: t('store.shared.uploaded', {
              element: t('store.admin.product.product_image')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.uploading_error', {
                element: t('store.admin.product.product_image')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  saveRegions({ commit, dispatch, state }, params) {
    return new Promise((resolve, reject) => {
      ProductService.saveRegions(state.product.id, params.regions)
        .then(response => {
          commit('SET_PRODUCT_REGIONS', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.saved', {
              element: t('store.admin.product.featured_regions')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.save_error', {
              element: t('store.admin.product.featured_regions')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  saveBrands({ commit, dispatch, state }, params) {
    return new Promise((resolve, reject) => {
      ProductService.saveBrands(state.product.id, params.brands)
        .then(response => {
          commit('SET_PRODUCT_BRANDS', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.saved', {
              element: t('store.admin.product.product_brands')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.save_error', {
              element: t('store.admin.product.product_brands')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
